import {
  Hammer,
  Wrench,
  Zap,
  Ruler,
  Droplets,
  Paintbrush,
  LayoutGrid,
  Package,
  PanelRight,
  Gift,
  MoveRight,
  Lightbulb,
  Plug,
  Bath,
  Toilet,
  ShowerHead,
  RectangleHorizontal,
  CircleUser,
  ShieldCheck,
  Star,
} from "lucide-react";

export const LABOUR_SCOPE = [
  { icon: Hammer, title: "Complete Strip-Out", items: ["Full removal of existing bathroom fixtures (excluding the ceiling)"] },
  { icon: Wrench, title: "Custom Plumbing", items: ["New plumbing tailored to your design specifications"] },
  { icon: Zap, title: "Electrical Work", items: ["Complete electrical setup to match your new layout"] },
  { icon: Ruler, title: "Niche or Ledge", items: ["Elegant shower/bath storage designed for convenience"] },
  { icon: Droplets, title: "Waterproofing", items: ["Complete waterproofing to ensure durability and prevent leaks"], badge: "7-Year Warranty" },
  { icon: Paintbrush, title: "Painting", items: ["Fresh, professional finish for the ceiling and back door"] },
  { icon: LayoutGrid, title: "Tiling", items: ["Full tiling of floors and walls, right up to the ceiling"], note: "600×600 or 600×300 tiles only — mosaic not included." },
  { icon: PanelRight, title: "Shower Screen", items: ["Included in your package at no additional cost"] },
];

export const PC_ITEMS = [
  { icon: Bath, label: "Bath" },
  { icon: Toilet, label: "Toilet suite" },
  { icon: ShowerHead, label: "Tapware & shower set" },
  { icon: RectangleHorizontal, label: "Vanity & basin" },
  { icon: CircleUser, label: "Mirror / mirror cabinet" },
];

export const BONUS = [
  {
    icon: MoveRight,
    title: "Minor Plumbing Adjustments",
    note: "Flexibility to relocate minor drainage as needed — e.g. moving your shower from one side of the bathroom to the other.",
  },
  {
    icon: Lightbulb,
    title: "LED Lighting",
    note: "Elegant LED lights installed inside all provided niches and underneath the vanity for enhanced ambiance.",
  },
  {
    icon: Plug,
    title: "Unlimited Power Points",
    note: "Ample electrical outlets to meet all your needs.",
  },
];

export const TRUST_BADGES = [
  {
    icon: ShieldCheck,
    title: "Licensed Builders",
    note: "Fully licensed NSW builders — all trades in-house, no subcontractors, no bluff.",
  },
  {
    icon: ShieldCheck,
    title: "Fully Insured + HBCF",
    note: "Complete insurance cover plus Home Building Compensation Fund on every job — on top of your fixed-price package.",
  },
  {
    icon: Star,
    title: "600+ 5-Star Reviews",
    note: "Real reviews from real Sydney homeowners — no fluff, no fake testimonials.",
  },
];

export const UNFORESEEN = {
  title: "Not included — unforeseen works",
  note: "Some things can only be discovered once demolition begins. If any of these come up, they are quoted separately at a fixed price before work proceeds — they are not part of this package price.",
  items: [
    "Asbestos wall removal and disposal",
    "Yellow tongue flooring replacement",
    "Rotten timbers",
    "Termite treatment",
  ],
};

export const PACKAGE_CONTENT = {
  "labour-only": {
    eyebrow: "Bathroom Renovation · Package 1 (Excluding PC Items)",
    heading: "Exactly what your $17,990 covers.",
    intro:
      "Transform your bathroom into a stunning oasis. You supply the PC items (vanity, toilet, tapware, tiles); we handle every licensed trade at one fixed price.",
    pc: {
      label: "You supply the PC items",
      note: "You choose your own vanity, toilet, tapware and tiles — we install them all professionally.",
    },
    groups: LABOUR_SCOPE,
    bonus: BONUS,
    unforeseen: UNFORESEEN,
  },
  "complete-package": {
    eyebrow: "Complete Bathroom Renovation · Package 2 (Including PC Items)",
    heading: "Exactly what your $23,990 covers.",
    intro:
      "Transform your bathroom into a luxurious retreat — all-inclusive. The full labour scope below, plus every PC item, conveniently listed at the bottom. Submit your details to receive the full supplier catalogue — or we'll walk you through it all onsite.",
    pc: {
      label: "All PC items included",
      items: [
        { icon: Bath, label: "Bath" },
        { icon: Toilet, label: "Toilet suite" },
        { icon: ShowerHead, label: "Tapware & shower set" },
        { icon: RectangleHorizontal, label: "Vanity & basin" },
        { icon: CircleUser, label: "Mirror / mirror cabinet" },
      ],
      note: "We supply and install all fixtures listed below — submit your details to receive the full catalogue, or we'll show you the range onsite.",
    },
    groups: LABOUR_SCOPE,
    bonus: BONUS,
    unforeseen: UNFORESEEN,
  },
};
